import React, { useEffect, useState } from "react";
import { Button, message, Steps, theme } from "antd";
import { Container, Row } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import OrderType from "./Steps/type";
import OrderInfo from "./Steps/orderDetails";
import ShippingInfo from "./Steps/shippingInfo";
import OrderSummary from "./Steps/orderSummary";
import CustomerDetails from "./Steps/customerDetails";
import { destore } from "../../store/features/orders/createSlice";
import axios from "../../services/axiosConfig";
import Helper from "../../services/Helper";

const CreateOrder = () => {
  const dispatch = useDispatch();
  const orderStoreDetails = useSelector((state) => state.order.orders);
  const { token } = theme.useToken();
  const [current, setCurrent] = useState(0);
  const [disabled, setDisabled] = useState(false);
  let navigate = useNavigate();

  const steps = [
    {
      title: "Order Type",
      content: <OrderType updateTab={setCurrent} />,
    },
    {
      title: "Order Details",
      content: <OrderInfo updateTab={setCurrent} />,
    },
    {
      title: "Shipping Details",
      content: <ShippingInfo updateTab={setCurrent} />,
    },
    {
      title: "Summary",
      content: <OrderSummary updateTab={setCurrent} />,
    },
  ];

  useEffect(() => {
    dispatch(destore());
  }, []);

  const next = () => {
    debugger;
    setCurrent(current + 1);
  };

  const prev = () => {
    debugger;
    setCurrent(current - 1);
  };

  const done = async () => {
    try {
      setDisabled(true);
      var data = await axios
        .post("/create-orders", orderStoreDetails)
        .catch((error) => {
          Helper.ErrorHanlder(error);
        });

      if (data && data.data) {
        message.success("Order created successfully");
        dispatch(destore());
        setDisabled(false);
        navigate("/orders");
      }
    } catch (error) {
      Helper.ErrorHanlder(error);
      setDisabled(false);
    }
  };

  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
  }));

  const contentStyle = {
    lineHeight: "260px",
    textAlign: "center",
    color: token.colorTextTertiary,
    backgroundColor: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    border: `1px dashed ${token.colorBorder}`,
    marginTop: 16,
  };

  return (
    <Container>
      <Row>
        <Steps current={current} items={items} />
        <div style={contentStyle}>{steps[current].content}</div>
        <div
          style={{
            marginTop: 24,
          }}
        >
          {current == 0 && (
            <Button type="primary" onClick={() => next()}>
              Next
            </Button>
          )}
          {current === steps.length - 1 && (
            <Button
              type="primary"
              disabled={disabled}
              onClick={(e) => {
                done();
              }}
            >
              Create
            </Button>
          )}
          {current == 11 && (
            <Button
              style={{
                margin: "0 8px",
              }}
              onClick={() => prev()}
            >
              Previous
            </Button>
          )}
        </div>
      </Row>
    </Container>
  );
};
export default CreateOrder;
